import ArticlePage from '../page-components/ArticlePage';
import { hydratePageComponent } from './base-script';

hydratePageComponent(ArticlePage);
